import { render } from "./LiquidationApprovalHistory.vue?vue&type=template&id=7b1a1b08"
import script from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"
export * from "./LiquidationApprovalHistory.vue?vue&type=script&lang=js"

import "./LiquidationApprovalHistory.vue?vue&type=style&index=0&id=7b1a1b08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__